import {Observable} from 'rxjs';
import {ArrayUtils} from "@shared/util/collections/collection-utils";

export class ResizeObservable extends Observable<ResizeObserverEntry[]> {
  private resizeObservers = new Set<ResizeObserver>();
  private elements = new Set<Element>();

  constructor(elem?: Element | Element[]) {
    super((subscriber) => {
      const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => subscriber.next(entries));
      this.elements.forEach(element => resizeObserver.observe(element));
      this.resizeObservers.add(resizeObserver);
      this.registerElement(elem);
      return () => {
        this.resizeObservers.delete(resizeObserver)
        resizeObserver.disconnect();
      };
    });
  }

  registerElement(element: Element | Element[]) {
    const elements = ArrayUtils.asArray(element);
    elements.forEach((elem) => {
      this.elements.add(elem);
      if (this.resizeObservers.size) {
        this.resizeObservers.forEach(resizeObserver => resizeObserver.observe(elem));
      }
    });
  }

  unregisterElement(element: Element | Element[]) {
    const elements = ArrayUtils.asArray(element);
    elements.forEach((elem) => {
      this.elements.delete(elem);
      if (this.resizeObservers.size) {
        this.resizeObservers.forEach(resizeObserver => resizeObserver.unobserve(elem));
      }
    });
  }
}
